/**
 * @file ヘッダー日時
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname HeaderDate
 * @classdesc ヘッダー日時
 */
export default class HeaderDate {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#now-date')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this.initialize();
	};


	/**
	 * 初期化
	 */
	initialize() {
		const now = new Date();
		const date = `令和${now.getFullYear() - 2018}年${Common.zeroPadding(now.getMonth() + 1, 2)}月${Common.zeroPadding(now.getDate(),2)}日 ${Common.zeroPadding(now.getHours(), 2)}:${Common.zeroPadding(now.getMinutes(), 2)}:${Common.zeroPadding(now.getSeconds(), 2)}`;
		this._$e.text(date);
		setInterval(() =>{
			const now = new Date();
			const date = `令和${now.getFullYear() - 2018}年${Common.zeroPadding(now.getMonth() + 1, 2)}月${Common.zeroPadding(now.getDate(),2)}日 ${Common.zeroPadding(now.getHours(), 2)}:${Common.zeroPadding(now.getMinutes(), 2)}:${Common.zeroPadding(now.getSeconds(), 2)}`;
			this._$e.text(date);
		}, 1000);
	};
}
 